import React from 'react';
import Grid from '@mui/material/Grid';
import moment from 'moment';
import Paper from '@mui/material/Paper';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import DefaultPreviewPdfFile from '../../../components/default-preview-pdf-file';
import { useOfficialDiaryDetailController } from './context/official-diary-detail-controller';
import { useOfficialDiaryDetailState } from './context/official-diary-detail-context';
import PageHeader from '../../../components/page-header';

export function OfficialDiaryDetailComponent() {
    useOfficialDiaryDetailController();
    const { officialDiaryDetail, officialDiaryFile } = useOfficialDiaryDetailState();

    return (
        <React.Fragment>
            <Grid item xs={12} md={12} lg={12}>
                <PageHeader
                    title="Detalhes do Diário Oficial"
                    subtitle={`Edição ${officialDiaryDetail?.editionNumber || ''} - ${officialDiaryDetail?.publicationDate ? moment(officialDiaryDetail.publicationDate).format('DD/MM/YYYY') : ''}`}
                    breadcrumbs={[
                        { label: 'SDP', href: '/sdp' },
                        { label: 'Diário Oficial', href: '/sdp/diario-oficial' },
                        { label: 'Detalhes' }
                    ]}
                />
            </Grid>

            <Grid item xs={7} md={7} lg={7}>
                <Paper
                    sx={{
                        p: 2,
                        display: 'flex',
                        flexDirection: 'column'
                    }}
                    elevation={3}
                >
                    <DefaultPreviewPdfFile props={{ file: officialDiaryFile }} />
                </Paper>
            </Grid>
            <Grid item xs={5} md={5} lg={5}>
                <Paper
                    sx={{
                        p: 2,
                        display: 'flex',
                        flexDirection: 'column'
                    }}
                    elevation={3}
                >
                    <Grid container spacing={2}>
                        <Grid item lg={2} sm={2} xl={2}>
                            <InputLabel>Nº Edição</InputLabel>
                            <OutlinedInput
                                disabled
                                value={officialDiaryDetail?.editionNumber}
                                fullWidth
                            />
                        </Grid>
                        <Grid item lg={2} sm={2} xl={2}>
                            <InputLabel>Ano</InputLabel>
                            <OutlinedInput
                                disabled
                                value={officialDiaryDetail?.yearPublication}
                                fullWidth
                            />
                        </Grid>
                        <Grid item lg={4} sm={4} xl={4}>
                            <InputLabel>Data da Edição</InputLabel>
                            <OutlinedInput
                                disabled
                                value={moment(officialDiaryDetail?.publicationDate).format("DD/MM/yyyy")}
                                fullWidth
                            />
                        </Grid>
                        <Grid item lg={4} sm={4} xl={4}>
                            <InputLabel>Fechada em</InputLabel>
                            <OutlinedInput
                                disabled
                                value={
                                    officialDiaryDetail?.closedOn !== null
                                        ? moment(officialDiaryDetail?.closedOn).format("DD/MM/yyyy HH:mm:ss")
                                        : null
                                }
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} md={12} lg={12}>
                            <InputLabel>Fechada por</InputLabel>
                            <OutlinedInput
                                disabled
                                value={officialDiaryDetail?.closedByUser}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} md={12} lg={12}>
                            <InputLabel>Entidade</InputLabel>
                            <OutlinedInput
                                disabled
                                value={officialDiaryDetail?.clientName}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} md={12} lg={12}>
                            <InputLabel>Descrição</InputLabel>
                            <OutlinedInput
                                disabled
                                multiline
                                rows={15}
                                value={officialDiaryDetail?.descriptions}
                                fullWidth
                            />
                        </Grid>
                        <Grid item lg={12} sm={12} xl={12} sx={{ textAlign: 'right' }}>
                            <ToggleButtonGroup
                                color="primary"
                                value={officialDiaryDetail?.isClosed}
                                sx={{ mr: 2 }}
                            >
                                <ToggleButton value={true}>Fechada</ToggleButton>
                                <ToggleButton value={false}>Aberta</ToggleButton>
                            </ToggleButtonGroup>

                            <ToggleButtonGroup
                                color="primary"
                                value={officialDiaryDetail?.isVisibility}
                            >
                                <ToggleButton value={true}>Visível</ToggleButton>
                                <ToggleButton value={false}>Invisível</ToggleButton>
                            </ToggleButtonGroup>
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
        </React.Fragment>
    );
}
